import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AppointmentState } from '../../model/appointment-book.models';
import { Resource } from '../../model/resource.model';
import ScrollView from 'devextreme/ui/scroll_view';

@Component({
  selector: 'app-appointment-resource',
  templateUrl: './appointment-resource.component.html',
  styleUrls: ['./appointment-resource.component.css'],
})
export class AppointmentResourceComponent implements OnChanges {
  // showWaitTime = true;
  appointmentState = AppointmentState.New;

  @Input() showLoading = false;
  @Input() resources: Resource[] = [];
  @Input() set aptState(state: AppointmentState) {
    this.appointmentState = state;
    this.showWaitTime = !(this.appointmentState && this.appointmentState > AppointmentState.New);
  }

  @Input() showWaitTime: boolean = true;
  @Input() showCustomText: boolean = false;
  @Input() showWarnings: boolean = true;
  @Input() allowSelectionAfterAptBooked: boolean = false;

  _resources: Resource[] = [];
  resourceSearchActive: boolean = false;

  private selectedResourceId = -1;
  @Input() public set selectedResource(Id: number) {
    this.selectItem(Id);
  }
  public get selectedResource() {
    return this.selectedResourceId;
  }

  @Output() onResourceSelected: EventEmitter<Resource> = new EventEmitter<Resource>();

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.resources?.currentValue) {
      this._resources = changes.resources.currentValue;
    }
  }

  onContentReady(e) {
    let instance = ScrollView.getInstance(e.element);
    instance.option('useNative', false);
  }

  itemClicked(e: Resource) {
    if (e.WaitTime == undefined) {
      return;
    }
    if (e.Selectable == false) {
      return;
    }

    // Do not allow changes after apt booked.
    if (this.allowSelectionAfterAptBooked == false) {
      if (this.appointmentState >= AppointmentState.Booked) {
        return;
      }
    }
    this.selectItem(e.ResourceId, true);
  }

  selectItem(Id: number, raiseEvent?: boolean) {
    if (this.selectedResourceId !== Id || this.allowSelectionAfterAptBooked == true) {
      this.selectedResourceId = Id;
      const item = this.resources.find((i) => i.ResourceId === Id);
      if (item) {
        this.resources.forEach((i) => (i.Selected = i.ResourceId === Id));
        console.log('Resource selected:', item);
        // this.selectedResourceId = Id;
        if (raiseEvent) {
          this.onResourceSelected.emit(item);
        }
      }
    }
  }

  onResourceSearchInput(e: any) {
    const input: string = (<string>e.event.target.value)?.toLowerCase();
    if (input && input.length >= 3) {
      this.resourceSearchActive = true;
      this._resources = this.resources.filter((i: Resource) => i.ResourceName.toLowerCase().includes(input));
    } else {
      this.resourceSearchActive = false;
      this._resources = this.resources;
    }
  }
}
